import { Database } from '@vuex-orm/core'
import MZCoupon from '../models/MZCoupon'
import mzcoupons from './modules/mzcoupons'
import MZInterestCategory from '../models/MZInterestCategory'
import mzinterestcategories from './modules/mzinterestcategories'
import MZLocation from '../models/MZLocation'
import mzlocations from './modules/mzlocations'
import MZLocationable from '../models/MZLocationable'
import mzlocationables from './modules/mzlocationables'
import MZLoyalty from '../models/MZLoyalty'
import mzloyalty from './modules/mzloyalty'
import MZUser from '../models/MZUser'
import mzusers from './modules/mzusers'

const database = new Database()
database.register(MZLocationable, mzlocationables)
database.register(MZInterestCategory, mzinterestcategories)
database.register(MZLocation, mzlocations)
database.register(MZCoupon, mzcoupons)
database.register(MZLoyalty, mzloyalty)
database.register(MZUser, mzusers)

export default database



// WEBPACK FOOTER //
// ./src/store/database.js